exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yd-table-footer[data-v-3de611d9] {\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n  -webkit-box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.05);\n}\n.content[data-v-3de611d9] {\n  white-space: wrap;\n}", ""]);

// exports
